import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useContext, useEffect, useState } from 'react';
import Swal from "sweetalert2";
import * as userService from '../services/userService'
import 'primeicons/primeicons.css';
import { SelectButton } from 'primereact/selectbutton';
import { FilterMatchMode, FilterService } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { RegisterContext } from '../../contexts/RegisterContext';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { rolesNames, rolesToBulgarian, rolesToNumbers, sizeOptions , roles } from '../../Shared/userManagmentOptions';
import { AddNewUser } from '../components/AddNewUser';
import { EgnValid } from '../../utils/EgnValidator';

export const ManageUsers = () => {



    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [size, setSize] = useState(sizeOptions[1].value);
    const [visible, setVisible] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        role: { value: null, matchMode: FilterMatchMode.EQUALS } // Добавяме филтър по роля
    });
    const { schools } = useContext(RegisterContext);
    const [schoolsOptions, setSchoolsOptions] = useState([])

    document.title = `Управление на потребители`;

    useEffect(() => {
        setLoading(true);

        userService.getAllPredefinedUsers()
            .then((data) => {
                setUsers(data)
                setLoading(false);
            })
            .catch((err) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: err.message,
                    icon: "warning",
                    button: "Добре",
                });
                setLoading(false);
            })
    }, [])

    useEffect(() => {
        setSchoolsOptions([{ id: 0, name: "без", shortName: "Няма" }, ...schools])
    }, [schools])

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const createNewUser = (e, formData) => {
        e.preventDefault();

        toggleDialog();
        setLoading(true)

        if (userFormIsValid(formData)) {
            if (formData.school?.id == null) {
                formData.school = { id: 0 }
            }

            const data = {
                egn: formData.egn,
                username: formData.username,
                password: formData.password,
                name: formData.name,
                phoneNumber: formData.phoneNumber,
                email: formData.email,
                userRole: formData.userRole.code,
                dzId: formData.userRole.code == 1 ? -1 : formData.school?.id,
                isActive: formData.isActive,
                changeGrao: formData.changeGrao ? 1 : 0
            }

            userService.createUser(data)
                .then((data) => {
                    setUsers((prevState) => [data, ...prevState]);
                    setLoading(false)
                })
                .catch((err) => {
                    Swal.fire({
                        title: "Възникна грешка",
                        text: err.message,
                        icon: "warning",
                        button: "Добре",
                    });
                    setLoading(false);
                })
        } else {
            setLoading(false);
        }

    }

    const activeDurectorAccounts = (e) => {
        e.preventDefault();
        setLoading(true)

        userService.activeDirectorsAccounts()
            .then((data) => {
                setUsers((prevState) => {
                    return prevState.map(user => {
                        if (user.role === "Director") {
                            return { ...user, isActive: true };
                        }
                        return user;
                    });
                });

                Swal.fire({
                    title: "Акаунтите са активирани!",
                    icon: "success",
                });
                setLoading(false)
            })
            .catch((err) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: err.message,
                    icon: "warning",
                    button: "Добре",
                });
                setLoading(false);
            })
    }

    const deactiveDurectorAccounts = (e) => {
        e.preventDefault();
        setLoading(true)

        userService.deactiveDirectorsAccounts()
            .then((data) => {
                setUsers((prevState) => {
                    return prevState.map(user => {
                        if (user.role === "Director") {
                            return { ...user, isActive: false };
                        }
                        return user;
                    });
                });

                Swal.fire({
                    title: "Акаунтите са деактивирани!",
                    icon: "success",
                });
                setLoading(false)
            })
            .catch((err) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: err.message,
                    icon: "warning",
                    button: "Добре",
                });
                setLoading(false);
            })
    }

    const userFormIsValid = (formData) => {
        if (!EgnValid(formData.egn)) {
            Swal.fire({
                title: "Възникна грешка",
                text: 'Невалидно ЕГН',
                icon: "error",
                button: "Добре",
            });

            return false;
        } else if (formData.name.length < 2) {
            Swal.fire({
                title: "Възникна грешка",
                text: 'Името трябва да бъде поне 3 символа',
                icon: "error",
                button: "Добре",
            });

            return false;
        } else if (!formData.userRole && !formData.role) {
            Swal.fire({
                title: "Възникна грешка",
                text: 'Полето за роля е задължително',
                icon: "error",
                button: "Добре",
            });

            return false;
        }

        return true;
    }

    const onRowEditComplete = (e) => {
        let { newData, index } = e;
        setLoading(true)
        if (userFormIsValid(newData)) {
            if (newData.school?.id == null) {
                newData.school = { id: 0 }
            }

            const data = {
                egn: newData.egn,
                username: newData.username,
                name: newData.name,
                userRole: rolesToNumbers[newData.role],
                dzId: rolesToNumbers[newData.role] == 1 ? -1 : newData.school?.id,
                isActive: newData.isActive,
                changeGrao: newData.changeGrao ? 1 : 0,
                phoneNumber: newData.phoneNumber || null,
                email: newData.email || null,
            }

            userService.editUser(newData.id, data)
                .then((data) => {
                    const updatedUsers = users.map(user =>
                        user.id === newData.id ? data : user
                    );
                    setUsers(updatedUsers);
                    setLoading(false)
                })
                .catch((err) => {
                    Swal.fire({
                        title: "Възникна грешка",
                        text: err.message,
                        icon: "warning",
                        button: "Добре",
                    });
                    setLoading(false);
                })
        } else {
            setLoading(false);
        }
    };

    const allowEdit = (rowData) => {
        return rowData.name !== 'Blue Band';
    };

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Търсене" />
                    <Dropdown
                        value={filters.role.value}
                        onChange={(e) => onRoleFilterChange(e.value)}
                        options={rolesNames}

                        placeholder="Филтрирай по роля"
                        showClear
                        className="w-12rem ms-3 custom-dropdown"
                    />
                </span>
                <div className='w-70 d-flex gap-2 justify-content-end'>
                    <Button tooltip="Добави потребител" tooltipOptions={{ position: 'top' }} icon="pi pi-user-plus" onClick={() => setVisible(true)} className='btn-prim' />
                    <Button tooltip="Активирай директорските акаунти" tooltipOptions={{ position: 'left' }} icon="pi pi-lock-open" onClick={activeDurectorAccounts} className='btn-prim-confirm' />
                    <Button tooltip="Деактивирай директорските акаунти" tooltipOptions={{ position: 'left' }} icon="pi pi-lock" onClick={deactiveDurectorAccounts} className='btn-prim-deny' />
                </div>
            </div>
        );
    };

    const toggleDialog = () => {
        setVisible(false);
    };

    const textEditor = (options) => {
        if (options.field == 'role') {
            return <Dropdown value={options.value} onChange={(e) => options.editorCallback(e.target.value)} options={rolesNames} className="w-100" />;
        } else if (options.field == 'school') {
            return <Dropdown value={options.value} onChange={(e) => options.editorCallback(e.target.value)} options={schoolsOptions} className="w-100" optionLabel="shortName" />;
        } else if (options.field == 'isActive' || options.field == 'changeGrao') {
            return <Checkbox checked={options.value ? true : false} onChange={(e) => options.editorCallback(e.target.checked)} />;
        } else {
            return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
        }
    };

    const activeBodyTemplate = (rowData) => {
        return <Checkbox
            inputId={rowData.id}
            name='active'
            checked={rowData.isActive}
            disabled
        />
    };

    const chAddressBodyTemplate = (rowData) => {
        return <Checkbox
            inputId={rowData.id}
            name='chAddress'
            checked={rowData.changeGrao ? true : false}
            disabled
        />
    };

    const roleBodyTemplate = (rowData) => {
        return <p>{rolesToBulgarian[rowData.role]}</p>
    };

    const schoolBodyTemplate = (rowData) => {
        return <p>{rowData.school?.shortName}</p>
    };

    const resetPasswordTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-refresh"
                tooltipOptions={{ position: 'left' }}
                className="p-button-rounded p-button-text"
                onClick={() => resetPassword(rowData.id)}
                tooltip="Нулиране на парола"
            />
        );
    };

    const resetPassword = (userId) => {
        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да нулирате паролата на потребителя?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                userService.resetPassword(userId)
                    .then((data) => {
                        setLoading(false)
                        Swal.fire({
                            title: "Успешно нулиране на парола",
                            text: `Новата парола на този потребител е: ${data.newPass}`,
                            icon: "success",
                            button: "Добре",
                        });
                    })
                    .catch((err) => {
                        Swal.fire({
                            title: "Възникна грешка",
                            text: err.message,
                            icon: "warning",
                            button: "Добре",
                        });
                        setLoading(false);
                    })

            }
        });
       
    };

    const rowClassName = (rowData) => {
        let className = '';

        const rowIndex = users.indexOf(rowData);

        if (rowData.isActive === false) {
            if (rowIndex % 2 === 1) {
                className += ' bg-dark-red';
            } else {
                className += ' bg-red';
            }
        }

        return className.trim();
    };

    const header = renderHeader();

    const onRoleFilterChange = (value) => {
        let _filters = { ...filters };
        _filters['role'].value = value;
        setFilters(_filters);
    };

    return (


        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Управление на потребители</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Управление на потребители</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">

                            <DataTable value={users} scrollable scrollHeight="74vh" editMode="row" dataKey="id" stripedRows filterDisplay="row" size='small' filters={filters} loading={loading}
                                header={header} onRowEditComplete={onRowEditComplete} emptyMessage="Няма намерени потребители."
                                rowClassName={rowClassName}>
                                <Column field="id" header="ID" style={{ maxWidth: '8rem', display: 'none' }} editor={(options) => textEditor(options)} />
                                <Column field="username" header="Потребителско име" style={{ width: '15%', maxWidth: '8rem' }} editor={(options) => textEditor(options)} />
                                <Column field="name" header="Име" style={{ width: '15%', maxWidth: '8rem' }} editor={(options) => textEditor(options)} />
                                <Column field="role" header="Роля" style={{ maxWidth: '8rem' }} editor={(options) => textEditor(options)} body={roleBodyTemplate} />
                                <Column field="school" header="Училище" style={{ width: '18%', maxWidth: '12rem' }} editor={(options) => textEditor(options)} body={schoolBodyTemplate} />
                                <Column field="egn" header="ЕГН" style={{ width: '10%', maxWidth: '8rem' }} editor={(options) => textEditor(options)} />
                                <Column field="email" header="Имейл" style={{ width: '10%', maxWidth: '8rem' }} editor={(options) => textEditor(options)} />
                                <Column field="phoneNumber" header="Телефон" style={{ width: '10%', maxWidth: '8rem' }} editor={(options) => textEditor(options)} />
                                <Column field="changeGrao" header="Промяна на адрес" style={{ width: '8%', maxWidth: '5rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center' }} editor={(options) => textEditor(options)} body={chAddressBodyTemplate} />
                                <Column field="isActive" header="Активен" style={{ width: '5%', maxWidth: '5rem' }} bodyStyle={{ textAlign: 'center' }} editor={(options) => textEditor(options)} body={activeBodyTemplate} />
                                <Column  rowEditor={allowEdit} headerStyle={{ width: '5%', minWidth: '2rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center' }}></Column>
                                <Column  body={resetPasswordTemplate} headerStyle={{ width: '5%', minWidth: '2rem' }} bodyStyle={{ textAlign: 'center' }} />
                            </DataTable>
                            <Dialog header={`Добавяне на потребител`} visible={visible} className="w-100-mob" style={{ width: '50vw' }} onHide={() => toggleDialog()} id={`addUser`}>
                                <AddNewUser createNewUser={createNewUser} schoolsOptions={schoolsOptions} />
                            </Dialog>
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}